export const TestId = {
  saveButton: 'importList-importListProduct-imageGallery-saveButton',
}
